import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SorteoData } from '@app/@shared/models/lottery.model';

@Component({
  selector: 'app-date-list',
  templateUrl: './date-list.component.html',
  styleUrl: './date-list.component.scss',
})
export class DateListComponent implements OnInit {
  @Input() dates: Date[] = [];
  @Input() selectable = false;
  @Input() multiple = true;
  @Input() sorteosData: SorteoData[] = [];
  selected: boolean[] = [];

  @Output() changeSelected = new EventEmitter<boolean[]>();
  @Output() dateSelected = new EventEmitter<SorteoData>();

  ngOnInit(): void {
    this.dates.forEach(() => {
      this.selected.push(false);
    });
    this.select(0);
  }

  select(i: number) {
    if (this.selectable) {
      if (this.multiple) {
        // if (i !== 0) {
        this.selected[i] = !this.selected[i];
        // }

        // this.selected[0] = true;
      } else {
        this.selected.forEach((s, ind) => {
          if (i === ind) {
            this.selected[ind] = !s;
          } else {
            this.selected[ind] = false;
          }
        });
      }

      this.changeSelected.emit(this.selected);

      if (this.sorteosData && this.sorteosData[i]) {
        this.dateSelected.emit(this.sorteosData[i]);
      }
    }
  }
}
